import styled from "styled-components";
import { Link } from "gatsby";

import logo from "../../images/wvs-logo.svg";

const LogoImage = styled.img`
  height: 45px;
  display: inline-block;
  vertical-align: middle;
`;

export const Logo = (props) => (
  <Link className={`logo ${props.className}`} to={"/"}>
    <LogoImage className={`logo__img`} src={logo} alt="WVS" />
  </Link>
);
